import React, { useEffect } from 'react';
import { usePrefs, useFlags, useRequestData } from 'wsm-common-data';
import clickpathGenerator from '../utils/clickpathGenerator';
import clickpathInjector from '../utils/clickpathInjector';
import { updateSession as trackingAttributesGenerator } from '../utils/trackingAttributesGenerator';
import trackingAttributesInjector from '../utils/trackingAttributesInjector';

if (typeof window !== 'undefined') {
	import('../utils/eventHandling/handleEvents.js').then((module) => {
		module.default(window);
	});
}

const Widget = () => {
	const { formChangeTypes, maxClickpathCount } = usePrefs();
	const { locale } = useRequestData();
	const {
		'ws-tracking-clickpath': wsTrackingClickpathEnabled,
		'enable-ws-tracking-attributes': enableTrackingAttributes
	} = useFlags();

	if (typeof window !== 'undefined') {
		window.DDC = window.DDC || {};
		window.DDC.WidgetData = window.DDC.WidgetData || {};
		window.DDC.WidgetData['ws-tracking'] =
			window.DDC.WidgetData['ws-tracking'] || {};
		window.DDC.WidgetData['ws-tracking'].formChangeTypes =
			formChangeTypes?.split(' ');
	}

	useEffect(() => {
		clickpathGenerator();
		if (enableTrackingAttributes) {
			const urlParams = window.DDC.getUrlParams() || {};
			trackingAttributesGenerator(urlParams);
			trackingAttributesInjector({ locale, urlParams });
		}
		if (wsTrackingClickpathEnabled) {
			clickpathInjector(parseInt(maxClickpathCount, 10));
		}
	});
	return <React.Fragment />;
};

export default Widget;
